export default {
  methods: {
    getImagePath (image) {
      const defaultImagePath = '/images/'
      return defaultImagePath + image
    }
  }
}
